<template>
  <div>
    <main-layout>
      <Mainmenu />
      <v-container>
        <div class="pt-2">
          <v-breadcrumbs :items="items">
            <template #item="props">
              <router-link
                :to="{ name: 'company-management' }"
                :class="[props.item.disabled && 'disabled']"
                >{{ props.item.text.toUpperCase() }}</router-link
              >
            </template>
          </v-breadcrumbs>
        </div>
        <div class="pt-2">
          <h1>{{ $t('branch_management') }} ({{ companyName }})</h1>
        </div>
        <div class="pt-3 text-xs-right">
          <v-btn dark depressed color="primary" @click="showManage = true">
            <em class="fa fa-plus pr-2" />
            <span>{{ $t('create_branch') }}</span></v-btn
          >
          <!-- <v-btn dark outline color="primary" @click="handleExportXlsx" :loading="exportLoading">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn> -->
        </div>
        <div>
          <v-data-table
            :headers="headers"
            :items="dataList"
            :pagination.sync="pagination"
            class="elevation-1 mt-3"
            hide-actions
          >
            <template #items="props">
              <tr>
                <td>{{ offset + props.index + 1 }}</td>
                <td>{{ props.item.branch_name || '-' }}</td>
                <td class="text-xs-right">
                  <v-btn fab small outline color="primary" @click="handleEdit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn fab small outline color="error" @click="handleDelete(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div class="mt-2">
            <v-pagination
              v-model="pageNumber"
              :total-visible="6"
              :length="pagelength"
              @input="handleChangePage"
            ></v-pagination>
          </div>
        </div>

        <v-dialog v-model="showManage" persistent width="500">
          <v-card class="pa-3">
            <BranchManage
              v-if="showManage"
              v-model="selectedBranch"
              :form-type="formType"
              @close="
                showManage = false
                selectedBranch = null
              "
              @success="handleManageSuccess"
            ></BranchManage>
          </v-card>
        </v-dialog>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import rootsApi from '@/api/roots'
import Mainmenu from './Mainmenu'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import BranchManage from './BranchManage'

export default {
  components: {
    Mainmenu,
    BranchManage
  },

  data() {
    return {
      items: [
        {
          text: 'Company Management',
          disabled: false,
          href: 'company-management'
        },
        {
          text: 'View',
          disabled: true,
          href: 'patient-history'
        }
      ],
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: 'id' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: this.$t('no.'), value: 'id', sortable: false },
        { text: this.$t('branch_name'), value: 'branch_name', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      isExport: false,
      dataList: [],
      showManage: false,
      exportLoading: false,
      formType: 'add',
      selectedBranch: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    companyName() {
      const vm = this
      const companyId = vm.$route && vm.$route.params.id
      const allCompanies = vm.$store.state.rootsMasterData.company
      let name = ''
      if (allCompanies) {
        name = allCompanies.find((el) => {
          return el.id === companyId
        })
      }

      return name ? name.company_name : '-'
    }
  },
  mounted() {
    this.handleGetBranch()
  },
  methods: {
    async handleGetBranch() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getCompanyWithBranch()
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.dataList = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async getCompanyWithBranch() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const companyId = vm.$route && vm.$route.params.id

        const response = await rootsApi.getCompanyWithBranch({
          config: {
            limit: limit,
            offset: vm.offset,
            company_id: companyId
          },
          pageId: vm.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getCompanyWithBranch()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            id: el.id,
            first_name: el.first_name,
            last_name: el.last_name
          }
        })

        const heading = [['ลำดับที่', 'ชื่อย่อบริษัท', 'ชื่อบริษัท']]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `company-list.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetBranch()
      }
    },
    handleEdit(item) {
      this.selectedBranch = item
      this.showManage = true
      this.formType = 'edit'
    },
    handleManageSuccess() {
      this.showManage = false
      this.selectedBranch = null
      this.handleGetBranch()
    },
    async handleDelete(item) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: this.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          const response = await vm.deleteBranch(item.id)

          if (response && response.status === 200) {
            vm.handleGetBranch()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteBranch(id) {
      const vm = this
      try {
        let data = {
          id: id
        }
        const response = await rootsApi.deleteBranch({
          config: data,
          pageId: vm.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
tr > td {
  white-space: nowrap;
}
.disabled {
  color: grey;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/Roots/BranchManagement.vue